import React from 'react';

/* eslint-disable */
export const CreateFormSvg = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "216",
  height: "167",
  viewBox: "0 0 365.22 282.95"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, `
        .cls-1{isolation:isolate;}
        .cls-2{fill:url(#linear-gradient);}
        .cls-3{opacity:0.07;fill:url(#linear-gradient-2);}
        .cls-4{fill:#4c9aff;}
        .cls-5{fill:url(#linear-gradient-3);}
        .cls-6,.cls-9{fill:#dfe1e5;}
        .cls-15,.cls-16,.cls-6{mix - blend - mode:multiply;}
        .cls-7{fill:#0052cc;}
        .cls-8{fill:#b2d4ff;}
        .cls-10{fill:url(#linear-gradient-4);}
        .cls-11{fill:url(#linear-gradient-5);}
        .cls-12{fill:url(#linear-gradient-6);}
        .cls-13{fill:url(#linear-gradient-7);}
        .cls-14{fill:none;stroke:#2684ff;stroke-miterlimit:10;stroke-width:8px;}
        .cls-15,.cls-16{opacity:0.39;}
        .cls-15{fill:url(#linear-gradient-8);}
        .cls-16{fill:url(#linear-gradient-9);}
        `), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: "43.88",
  y1: "263.33",
  x2: "351.09",
  y2: "-43.88",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#dfe1e5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#fafbfc"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: "135.86",
  y1: "138.06",
  x2: "135.86",
  y2: "235.8",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#091e42"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#091e42",
  stopOpacity: "0.1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: "10.35",
  y1: "146.56",
  x2: "311.65",
  y2: "146.56",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#b2d4ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.02",
  stopColor: "#b5d6ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.13",
  stopColor: "#c8dfff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.26",
  stopColor: "#d4e6ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.43",
  stopColor: "#dceaff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.79",
  stopColor: "#deebff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: "49.65",
  y1: "180.3",
  x2: "269.79",
  y2: "180.3",
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-5",
  x1: "37.04",
  y1: "209.41",
  x2: "338.35",
  y2: "209.41",
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-6",
  x1: "3.07",
  y1: "266.43",
  x2: "303.37",
  y2: "266.43",
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-7",
  x1: "49.65",
  y1: "236.32",
  x2: "269.79",
  y2: "236.32",
  xlinkHref: "#linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-8",
  x1: "187.7",
  y1: "713.48",
  x2: "187.7",
  y2: "741.99",
  gradientTransform: "matrix(1, 0, 0, -1, 0, 907.97)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#b2d4ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.87",
  stopColor: "#b2d4ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#b2d4ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-9",
  x1: "189.7",
  y1: "659.36",
  x2: "189.7",
  y2: "684.03",
  xlinkHref: "#linear-gradient-8"
})), /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-2",
  width: "365.22",
  height: "249.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M244.35,248.89c-90.8.08-228.87,0-228.87,0L36.94,123.29h219.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M40.05,90.07H325.34a3,3,0,0,1,3,3v37.05a0,0,0,0,1,0,0H37a0,0,0,0,1,0,0V93.08A3,3,0,0,1,40.05,90.07Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-5",
  points: "338.35 163.52 47.04 163.52 37.04 129.61 328.35 129.61 338.35 163.52"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: "37.35",
  y: "32.72",
  width: "174.7",
  height: "7"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-6",
  x: "37.35",
  y: "49.52",
  width: "127.57",
  height: "7"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-7",
  x: "52.13",
  y: "107.11",
  width: "186.18",
  height: "7"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-8",
  x: "229.2",
  y: "18.12",
  width: "52.93",
  height: "52.93",
  rx: "4.24"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-9",
  x: "297.53",
  y: "30.42",
  width: "28.32",
  height: "28.32",
  rx: "3.56"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-10",
  points: "338.35 163.47 47.04 163.47 37.04 197.12 328.35 197.12 338.35 163.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-11",
  points: "338.35 221.8 47.04 221.8 37.04 197.02 328.35 197.02 338.35 221.8"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "341.35 282.95 50.04 282.95 41.04 249.91 332.35 249.91 341.35 282.95"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-13",
  points: "338.35 221.77 47.04 221.77 41.04 250.88 332.35 250.88 338.35 221.77"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-14",
  points: "238.44 45.85 250.93 58.54 273.92 29.16"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-15",
  points: "338.35 163.47 47.04 163.47 37.04 197.12 328.35 197.12 338.35 163.47"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-16",
  points: "338.35 221.77 47.04 221.77 41.04 250.88 332.35 250.88 338.35 221.77"
})))));